export const _LOAD_MODEL_ = 'Load:CustomerModel';
export const _DELETE_CUSTOMER_ = 'Delete:Customer';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _SAVE_CUSTOMER_SUCCESS_ = 'Save:CustomerSuccess';

export const ADDRESS = {
  id: null,
  city: null,
  label: 'Endereço Principal',
  state: null,
  number: null,
  street: null,
  address: null,
  country: 'BR',
  zipcode: null,
  address2: null,
  district: null,
};

export const CONTACT = {
  id: null,
  name: '',
  email: null,
  phone: null,
  document: null,
  customer_id: null,
};

export const PROJECT = {
  id: null,
  label: 'Obra 1',
  address: { ...ADDRESS },
  address_id: null,
  status_id: 1,
  finished_at: null,
  comment: null,
};

export const MODEL = {
  id: null,
  name: null,
  type: 'individual',
  email: null,
  phone: null,
  comment: null,
  document: null,
  projects: [],
  contacts: [{ ...CONTACT }],
  addresses: [{ ...ADDRESS }],
  started_at: new Date(),
  state_registration: '',
};
